import { Route, Routes, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Spinner from '../../shared/spinner';

const Home = lazy(() => import('./home'));
const About = lazy(() => import('./about'));
const Properties = lazy(() => import('./properties'));
const PropertyDetail = lazy(() => import('./properties/detail'));
const FAQs = lazy(() => import('./faqs'));
const Contact = lazy(() => import('./contact'));
const TermsAndConditions = lazy(() => import('./terms-and-conditions'));

export const Landing = () => {
  return (
    <Suspense fallback={<Spinner text={'Loading...'}
                                 style={{ padding: '100px' }}/>}>
      <Routes>
        <Route path={'/'} element={<Home/>}/>
        <Route path={'/about'} element={<About/>}/>
        <Route path={'/properties'} element={<Properties/>}/>
        <Route path={'/properties/:propertyID'} element={<PropertyDetail/>}/>
        <Route path={'/faqs'} element={<FAQs/>}/>
        <Route path={'/contact'} element={<Contact/>}/>
        <Route path={'/terms'} element={<TermsAndConditions/>}/>
        <Route path={'*'} element={<Navigate to={'/not/found'}/>}/>
      </Routes>
    </Suspense>
  );
}

export default Landing;